import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import columns from "./Table/columns";
import data from "./Table/data";
import Filters from "./Table/Filters";

import { useContext } from "./Context";

export default function Table() {
  const { dispatch, actions, state } = useContext();

  const [keyword, setKeyword] = useState("");
  const [planStatus, setPlanStatus] = useState("");
  const [renewalMethod, setRenewalMethod] = useState("");
  const [renewalPeriod, setRenewalPeriod] = useState("");

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  return (
    <>
      <Filters
        keyword={keyword}
        setKeyword={setKeyword}
        setPlanStatus={setPlanStatus}
        setRenewalMethod={setRenewalMethod}
        setRenewalPeriod={setRenewalPeriod}
      />
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={
            data(
              state.plans,
              keyword,
              planStatus,
              renewalMethod,
              renewalPeriod
            ) || []
          }
          noDataComponent={
            <div className="mt20">
              {state.plans == null
                ? "Please, wait ..."
                : "No matching records found"}
            </div>
          }
          defaultSortFieldId={5}
          persistTableHead={true}
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: "All",
          }}
        />
      </div>
    </>
  );
}
